<template>
  <!-- 全局 头部导航 -->
  <div :style="{ 'font-family': familyFt, 'font-size': navFont }">
    <div :class="[
        'topNav',
        { 'topNav--dark': type === 'dark' },
        { 'topNav-dropBg': dropBg && type === 'dark', 'topNav-dropBg': dropBg },
      ]" class="" :style="{
        background: colorBg,
        height: navHeight,
        'box-shadow': dropBg && type === 'dark' ? commColor.isCommShadow : isShadow,
        position: isFixed ? 'absolute' : '',
      }">
      <div class="navContent" :style="{ height: navHeight }">
        <div class="navLeft flex_center2">
          <img src="../../../../../../static/img/蓝.svg" alt="" class="icon-width" @click="goBaiyun" />

          <ul :style="[
              {
                color: !dropBg ? colorFz : commColor.listCommFz,
              },
            ]" class="flex_center2 first_ul">
            <li v-for="(navItem, navIndex) in navListData" :key="navIndex" class="titleActive tishi bottom_line_rel" :class="[
                isHig() === navItem.titleId ? 'active' : '',
                {
                  titleActiveYearNew: dropBg && openMode == 2,
                  yearNewActive: dropBg && isHig() == navItem.titleId && openMode == 2,
                },
              ]" :style="styleObject" @mouseover="navOver(navIndex)" @mouseout="navOut(navIndex)">
              <!-- 判断运商通  添加升级照片 -->
              <img v-if="navItem.nameTitle == '运商通'" class='sj_img' src="../../../../../../static/newStatic/img/label_overall_hot.png" width='30px' height='14px'>
              <template>
                <a class="title-item" v-if="navItem.nameTitle != '我的百运' && navItem.nameTitle != '首页'" :style="{ 'line-height': navHeight }" :href="navIndex !== 1 ? $nuxtPage + navItem.urlHref : navItem.urlHref" :target="navIndex !== 1 ? '_blank' : ''">
                  {{ navItem.nameTitle }}<span class="new-tab" v-if="navItem.nameTitle == '物流工具' || navItem.nameTitle == '生态合作'"></span>
                </a>
                <a class="title-item my-baiYun" v-if="navItem.nameTitle == '首页'" :style="{ 'line-height': navHeight }" :href="navIndex !== 1 ? $nuxtPage + navItem.urlHref : navItem.urlHref" :target="navIndex !== 1 ? '_blank' : ''">
                  <span>{{ navItem.nameTitle }}</span>
                </a>
                <!-- 我的百运 -->
                <a class="title-item my-baiYun" v-if="navItem.nameTitle == '我的百运'" :style="{ 'line-height': navHeight }" :target="navIndex !== 1 ? '_blank' : ''">
                  <span @click="
                      toMyBaiYun(
                        navIndex !== 1 ? $nuxtPage + navItem.urlHref : navItem.urlHref
                      )
                    ">{{ navItem.nameTitle }}</span>
                  <!-- <img
                    v-if="navItem.nameTitle == '我的百运'"
                    class="my-baiYun-icon"
                    src="../../../../../../static/newStatic/img/indexPage/全新升级@2x.png"
                    width="68px"
                    height="22px"
                  /> -->
                </a>
              </template>
              <!-- <i class="fa" v-if="navItem.isShowMore || navItem.moreSubData.length > 0"> -->
              <!-- <iconComm v-if="openMode == 1" iconNameCard="icon-xiala" size="16" :iconColor="type == 'default' ? '#777777' : '#FFFFFF'"></iconComm>
                <iconComm v-if="openMode == 2" iconNameCard="icon-xiala" size="16" :iconColor="dropBg ? '#777777' : '#FFFFFF'"></iconComm> -->
              <!-- </i> -->
              <i class="fa" v-if="navIndex == 0">
                <div :class="isSelect == 0 || shouyeShow ? 'isSelect0' : 'unSelect0'"></div>
              </i>
              <i class="fa" v-if="navIndex == 3">
                <div :class="isSelect == 3 || wuliuShow ? 'isSelect1' : 'unSelect1'"></div>
              </i>
              <i class="fa" v-if="
                  (navItem.isShowMore || navItem.moreSubData.length > 0) && navIndex !== 3
                ">
                <div :class="
                    isSelect == navIndex ? 'isSelect' + navIndex : 'unSelect' + navIndex
                  "></div>

                <!-- <div :class="
                    isSelect == navIndex ? 'isSelect' + navIndex : 'unSelect4'
                  "></div> -->
              </i>
              <i class="fa" v-if="navIndex == 6">
                <div :class="isSelect == 6 || knowShow ? 'isSelect1' : 'unSelect1'"></div>
              </i>
              <!-- <img v-if="navItem.nameTitle == '首页'" class="bq-img" src="../../../../../../static/newStatic/img/newYear/标签查价下单@2x.png" width="56px" height="18px" /> -->
              <div class="bottom_line_nav" v-if="isHig() === navItem.titleId"></div>
              <el-collapse-transition v-if="navIndex !== 3">
                <div class="navBoxSub-shadow topTipBox" v-if="navTopAtv && navItem.moreSubData.length > 0" @mouseover="navTopAtv = true" @mouseleave="navTopAtv = false">
                  <div class="flex_col_center navBoxSub">
                    <div class="navBoxSub_title flex_center" v-for="(item, index) in navItem.moreSubData" :key="index">
                      <!-- <section class="aHov"> -->
                      <div class="aCol" v-if="navItem.titleId != 4" @click="hrefMenu(index, item, navItem)">
                        {{ item.title }}
                      </div>
                      <a class="aCol" v-else :href="$nuxtPage + item.urlSubHref" target="_self">{{ item.title }}</a>
                      <!-- </section> -->
                    </div>
                  </div>
                </div>
              </el-collapse-transition>
            </li>
            <!-- 菜单首页栏的悬浮框 -->
            <transition name="xiala">
              <div class="shouye_show" v-show="shouyeShow" @mouseout="closeshouyeTip" @mouseover="showshouyeTip">
                <div>
                  <div class="show_title">查价/下单</div>
                  <div class="list_1">
                    <div class="shouye_item" v-for="(item, index) in checkList" :key="index" @click="goCheck(item.link)">
                      <svg-icon :name="item.svgName" size="24" class="svgStyle"></svg-icon>
                      <div>{{ item.title }}</div>
                    </div>
                  </div>
                  <div class="show_title">更多服务</div>
                  <div class="list_1">
                    <div class="shouye_item" v-for="(item, index) in serviceList" :key="index" @click="goCheck(item.link)">
                      <svg-icon :name="item.svgName" size="24" class="svgStyle"></svg-icon>
                      <div>{{ item.title }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
            <!-- 了解百运的悬浮框 -->
            <transition name="xiala">
              <div class="knowBy_show" v-show="knowShow" @mouseleave="closeKnowTip" @mousemove="showKnowTip">
                <div class="knowBy-show-content">
                  <div class="content-title">企业支持</div>
                  <div class="item" v-for="(item,index) in supportList" :key="index" @click="goCheck(item.link)">
                    <img :src="item.imgUrl">
                    <div>
                      <div class="item-title">{{item.title}}</div>
                      <div class="item-text">{{item.text}}</div>
                    </div>
                  </div>
                </div>
                <div class="knowBy-show-content">
                  <div class="content-title">关于我们</div>
                  <div class="item" v-for="(item,index) in aboutUsList" :key="index" @click="goCheck(item.link)">
                    <img :src="item.imgUrl">
                    <div>
                      <div class="item-title">{{item.title}}</div>
                      <div class="item-text">{{item.text}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
            <!-- 物流栏的悬浮框 -->
            <transition name="xiala">
              <div class="wuliu_show" v-show="wuliuShow" @mouseout="closewuliuTip" @mouseover="showwuliuTip">
                <div>
                  <div class="wuliu_title">百运工具</div>
                  <div class="list_1">
                    <div class="wuliu_item" v-for="(item, index) in logisticsToolsListone" :key="index" @click="goCheck(item.link)">
                      <img :src="item.imgUrl" class="svgStyle" />
                      <div>{{ item.title }}</div>
                    </div>
                  </div>
                  <div class="list_2">
                    <div class="wuliu_item" v-for="(item, index) in logisticsToolsListTwo" :key="index" @click="goCheck(item.link)">
                      <img :src="item.imgUrl" class="svgStyle" />
                      <div>{{ item.title }}</div>
                    </div>
                  </div>
                  <div class="list_21">
                    <div class="wuliu_item" v-for="(item, index) in logisticsToolsListTwoOne" :key="index" @click="goCheck(item.link)">
                      <img :src="item.imgUrl" class="svgStyle" />
                      <div>{{ item.title }}<span class="new-logisticstool" v-if="item.title == '快递燃油费率'"></span></div>
                    </div>
                  </div>
                  <template v-if="logisticToolMenu.length">
                    <div class="wuliu_title logisticTool-title">其他工具</div>
                    <div class="list_3">
                      <!-- <div
                      class="wuliu_item"
                      v-for="(item, index) in logisticsToolsListThree"
                      :key="index"
                      @click="goCheck(item.link)"
                    >
                      <div class="logistics_0 svgStyle" v-if="index == 0"></div>
                      <div class="logistics_1 svgStyle" v-if="index == 1"></div>
                      <div class="logistics_2 svgStyle" v-if="index == 2"></div>
                      <div class="logistics_3 svgStyle" v-if="index == 3"></div>
                      <div>{{ item.title }}</div>
                    </div> -->
                      <template v-for="(item, index) in logisticToolMenu">
                        <div class="wuliu_item" :key="index" v-if="item.title !== '百运工具'" @click="goCheck(index,0) ">
                          <div class="logistics_0 svgStyle" v-if="item.title == 'FBA工具'"></div>
                          <div class="logistics_1 svgStyle" v-else-if="item.title == '快递工具'"></div>
                          <div class="logistics_2 svgStyle" v-else-if="item.title == '空运工具'"></div>
                          <div class="logistics_3 svgStyle" v-else-if="item.title == '海运工具'"></div>
                          <div class="logistics_4 svgStyle" v-else></div>

                          <div>{{ item.title }}</div>
                        </div>
                      </template>
                    </div>
                  </template>
                </div>
              </div>
            </transition>
          </ul>
          <template v-if="loginInfos.LogInType == 1 && isQuestion && isFive && IsQuestionnaire">
            <!-- 年度调查问卷 -->
            <img v-if="isNewYear" src="../../../../../../static/newStatic/img/newYear/标签调查问卷-券@2x.png" width="90px" height="28px" alt="调查问卷" style="margin-right: 16px; cursor: pointer" @click="handlerQuestionnaireDialog(true)" />
            <!-- 普通调查问卷 -->
            <img v-else src="../../../../../../static/newStatic/img/newYear/调查问卷-紫色@2x.png" width="112px" height="32px" alt="调查问卷" style="margin-right: 16px; cursor: pointer" @click="handlerQuestionnaireDialog(true)" />
          </template>
        </div>
        <div class="navRight flex">

          <div>
            <order-search :ordKeyWord="ordKeyWord" @submitSearch="submitSearch"></order-search>
          </div>
          <div class="marg-l-r16">
            <div class="marSales r" @mouseenter="
                () => {
                  rightTopMessageShow = true;
                  svgMessage = 'xiaoxi_hover';
                }
              " @mouseleave="
                () => {
                  rightTopMessageShow = false;
                  svgMessage = 'xiaoxi_nomal';
                }
              ">
              <!-- 新通知 -->
              <el-badge :is-dot="messageTotal > 0">
                <div style="padding-bottom: 20px">
                  <!-- <svg-icon :name="svgMessage" size="16"></svg-icon> -->
                  <div style="position: relative">
                    <svg-icon :name="svgMessage" size="16"></svg-icon>
                    <right-top-message v-model="messageTotal" :IsShow="rightTopMessageShow"></right-top-message>
                  </div>
                </div>
              </el-badge>
              <!-- <right-top-message v-model="messageTotal" :IsShow="rightTopMessageShow"></right-top-message> -->
            </div>
          </div>
          <div @mouseover="show = true" @mouseleave="show = false">
            <div class="flex headportrait">
              <div class="flex">
                <img :src="
                    itemurl
                      ? ((itemurl.indexOf('http') != -1) ? itemurl : ($apiFileCloud + itemurl))
                      : require('../../../../../../static/img/userInfo/user_Ava.png')
                  " class="info_login" />
                <div class="w_ellipsis info_name_title" alt="百运网国际快递">
                  {{ CustomerName }}
                </div>
              </div>
            </div>
            <div class="noshow" v-if="show" id="myPanel">
              <ul>
                <li class="information" v-if="isAuthentication">
                  <a :href="'/myInfo/personalCenter'" @mouseenter="
                      () => {
                        svgUserInfo = 'geren_hover';
                      }
                    " @mouseleave="
                      () => {
                        svgUserInfo = 'geren_nomal';
                      }
                    ">
                    <svg-icon :name="svgUserInfo" size="16"></svg-icon>
                    <!-- <img src="../../../../../../static/img/other/personal.svg" class="img--right-icon"> -->
                    <span>个人信息</span>
                  </a>
                </li>
                <li class="password">
                  <a :href="'/myInfo/personalCenter?page=advise'" @mouseenter="
                      () => {
                        svgAdvise = 'fanjkui_hover';
                      }
                    " @mouseleave="
                      () => {
                        svgAdvise = 'fanjkui_nomal';
                      }
                    ">
                    <svg-icon :name="svgAdvise" size="16"></svg-icon>
                    <!-- <img src="../../../../../../static/img/other/advise.svg" class="img--right-icon"> -->
                    <span>建议反馈</span>
                  </a>
                </li>
                <li class="quit">
                  <a @click="delToken" :href="this.$nuxtPage" @mouseenter="
                      () => {
                        svgLoginOut = 'tuichu-xuanting';
                      }
                    " @mouseleave="
                      () => {
                        svgLoginOut = 'tuichu-moren';
                      }
                    ">
                    <svg-icon :name="svgLoginOut" size="16"></svg-icon>
                    <!-- <img src="../../../../../../static/img/other/logout.svg" class="img--right-icon"> -->
                    <span>退出登录</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- <div :style="{ height: isFoodHeight }"></div> -->
    </div>
    <QuestionnaireDialog v-if="questionnaireDialogValue" @closeDialog="handlerQuestionnaireDialog"></QuestionnaireDialog>
    <email-dialog v-model="isShowEmailDialog" :email="email"></email-dialog>
    <mobile-dialog v-model="isShowMobileDialog" :isBothBiddingError="isBothBiddingError" @openEmailDialog="
        (val) => {
          isShowEmailDialog = val;
        }
      " :mobile="mobilePhone"></mobile-dialog>
  </div>
</template>
<script src="~/plugins/version.js"></script>

<script type="text/ecmascript-6">
import bus from "@/ask/eventBus";

import { fetch, post } from "@/ask/axios";
import { getCookie, delCookie, setCookie } from "@/ask/cookiejs";
import OrderSearch from "./../OrderSearch.vue"
import rightTopMessage from "../../../public/rightTopMessage/index.vue"; // 系统消息弹框
import emailDialog from "../bindingDialog/emailDialog.vue"
import mobileDialog from "../bindingDialog/mobileDialog.vue"
import QuestionnaireDialog from './questionnaireDialog.vue';
export default {
  components: { OrderSearch, rightTopMessage, emailDialog, mobileDialog, QuestionnaireDialog },
  inject: ["reload"] /*注入reload方法*/,
  name: 'navTopHeader',
  props: {
    // 导航字体文字规范
    familyFt: {
      type: [String],
      default: '',
    },
    // 导航字体文字大小
    navFont: {
      type: [String, Number],
      default: 16 + 'px',
    },
    // 显示LOGO状态
    type: {
      type: [String],
      default: 'default'
    },
    // 开启模式 1.默认导航LOGO  2.监听滚动 导航LOGO颜色变化
    openMode: {
      type: [Number, String],
      default: 1
    },
    // logo大小
    navLogo: {
      type: [String, Number],
      // default: 40 + 'px',
      default: 38 + 'px',
    },
    // logo其他颜色
    colorLogoS: {
      type: [String, Number],
      default: '#0046B9',
    },
    // logo白色
    colorLogoWhite: {
      type: [String, Number],
      default: '#fff',
    },
    // 导航高度
    navHeight: {
      type: [String, Number],
      default: 64 + 'px',
    },
    // 导航背景颜色
    colorBg: {
      type: [String],
      default: '#FFF',
    },
    // 导航阴影
    isShadow: {
      type: [String, Number],
      default: '0px 2px 8px 0px rgba(0, 0, 0, 0.08)',
    },
    // 导航是否固定
    isFixed: {
      type: [Boolean],
      default: true,
    },
    // 是否 nav到内容间距
    isFoodHeight: {
      type: [Number, String],
      default: 64 + 'px',
    },
    // 导航列表数据展示
    navListDataProps: {
      type: [Array],
      default: () => [
        {
          nameTitle: '首页',
          titleId: 1,//是否选中高亮 由isHig()控制，之前代码逻辑
          urlHref: "",
          isShowMore: false,//是否 显示其他更多信息
          moreSubData: [],//获取子数据
        },
        {
          nameTitle: '我的百运',
          titleId: 7,//是否选中高亮 由isHig()控制，之前代码逻辑
          urlHref: "customerCenter",//是false 打开一个新平台页面
          isShowMore: false,//是否 显示其他更多信息
          moreSubData: [],//获取子数据
        },

        {
          nameTitle: '百运百科',
          titleId: 4,//是否选中高亮 由isHig()控制，之前代码逻辑
          urlHref: "newsIndexquanbu1",
          isShowMore: true,//是否 显示其他更多信息
          moreSubData: [
            {
              title: '物流资讯',
              urlSubHref: "newsIndexwuliuzixun1",
              logo: 'fa colIcon1'
            },
            {
              title: '电商资讯',
              urlSubHref: "newsIndexwaimaozixun1",
              logo: 'fa colIcon1'
            },
            {
              title: '物流百科',
              urlSubHref: "newsIndexwuliuzhishi1",
              logo: 'fa colIcon1'
            },
            {
              title: '外贸百科',
              urlSubHref: "newsIndexwaimaobaike1",
              logo: 'fa colIcon1'
            },
            {
              title: '外贸经验',
              urlSubHref: "newsIndextradeshare1",
              logo: 'fa colIcon1'
            },
            {
              title: '邮寄经验',
              urlSubHref: "newsIndexmail1",
              logo: 'fa colIcon1'
            },
            {
              title: '重要公告',
              urlSubHref: "newsIndextonggaonews1",
              logo: 'fa colIcon1'
            },
          ],//获取子数据
        },
        {
          nameTitle: '物流工具',
          titleId: 3,//是否选中高亮 由isHig()控制，之前代码逻辑
          urlHref: "Special/index.html",
          isShowMore: true,//是否 显示其他更多信息
          moreSubData: [],//获取子数据
        },
        // {
        //   nameTitle: '关于我们',
        //   titleId: 5,//是否选中高亮 由isHig()控制，之前代码逻辑
        //   urlHref: "aboutBy/aboutByCent",
        //   isShowMore: true,//是否 显示其他更多信息
        //   moreSubData: [
        //     {
        //       title: '关于百运',
        //       urlSubHref: "aboutBy/aboutByCent",
        //       logo: 'fa colIcon1'
        //     },
        //     {
        //       title: '招贤纳士',
        //       urlSubHref: "aboutBy/joinUs",
        //       logo: 'fa colIcon1'
        //     }, //该功能先不展示
        //     {
        //       title: '联系我们',
        //       urlSubHref: "aboutBy/contact",
        //       logo: 'fa colIcon1'
        //     },
        //   ],//获取子数据
        // },
        // {
        //   nameTitle: '开放平台',
        //   titleId: 6,//是否选中高亮 由isHig()控制，之前代码逻辑
        //   urlHref: "openPlatform",//是false 打开一个新平台页面
        //   isShowMore: false,//是否 显示其他更多信息
        //   moreSubData: [],//获取子数据
        // },
        // {
        //   nameTitle: '运商通',
        //   titleId: 8,//是否选中高亮 由isHig()控制，之前代码逻辑
        //   urlHref: "ystIndex",//是false 打开一个新平台页面
        //   isShowMore: false,//是否 显示其他更多信息
        //   moreSubData: [],//获取子数据
        // },
        {
          nameTitle: '生态合作',
          titleId: 8,//是否选中高亮 由isHig()控制，之前代码逻辑
          urlHref: 'ecologicalCooperation',//是false 打开一个新平台页面
          isShowMore: false,//是否 显示其他更多信息
          moreSubData: [],//获取子数据
        },
        {
          nameTitle: '诚邀代理',
          titleId: 9,//是否选中高亮 由isHig()控制，之前代码逻辑
          urlHref: 'supplierIndex',//是false 打开一个新平台页面
          isShowMore: false,//是否 显示其他更多信息
          moreSubData: [],//获取子数据
        },
        {
          nameTitle: '了解百运',
          titleId: 6,//是否选中高亮 由isHig()控制，之前代码逻辑
          urlHref: 'aboutBy/aboutByCent',//是false 打开一个新平台页面
          isShowMore: false,//是否 显示其他更多信息
          moreSubData: [],//获取子数据
        },
      ],
    },
    // 导航列表字体颜色
    colorFz: {
      type: [String],
      default: '#333333',
    },
    // 导航列表宽度最大
    navListMax: {
      type: [String, Number],
      default: 800 + "px",
    },
    // 导航列表宽度最小
    navListMin: {
      type: [String, Number],
      default: 412 + "px",
    },
    // 导航登陆注册字体颜色
    colorFzLogin: {
      type: [String],
      default: '#333',
    },
    // 鼠标滑动和选中 字体颜色改变
    colorFzHover: {
      type: [String],
      default: '#0046B9',
    },
    // 展示省略号，宽度
    ellipsFzLogin: {
      type: [String, Number],
      default: 88 + 'px',
    },
    // 整体 导航默认 颜色大致不咋修改
    commColor: {
      type: [Object],
      default: () => ({
        listCommFz: '#333333',
        loginCommFz: '#333',
        commFzHover: '#0046B9',
        isCommShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.08)',
      })
    },

  },
  data() {
    return {
      loginInfos: {},
      isQuestion: true, // 年度问卷状态
      isFive: true,
      questionnaireDialogValue: false, // 调查问卷
      ordKeyWord: '',//搜索关键词
      navTopAtv: true,
      api: {
        url: "",
        param: "",
        response: {},
        message: "",
      },
      checkList: [
        {
          title: "国际快递",
          svgName: "fe_kuaidi_namal",
          link: "exp/list/1.html"
        },
        {
          title: "FBA头程",
          svgName: "fe_fba_nomal",
          link: "fba/list/1.html"
        },
        {
          title: "国际专线",
          svgName: "fe_zhuanxian_nomal",
          link: "specialLine/LineList/1.html"
        },
        {
          title: "小包专线",
          svgName: "fe_xiaobao_normal",
          link: "specialLinePacket/list/1.html"
        },
        {
          title: "国际空运",
          svgName: "fe_kongyun_nomal",
          link: "frontAirList/1.html"
        },
        {
          title: "海运散货",
          svgName: "fe_haiyun_nomal",
          link: "sea/list/1.html"
        }
      ],
      serviceList: [
        {
          title: "在线询盘",
          svgName: "fe_xunpan_nomal",
          link: "frontInquiry"
        },
        {
          title: "到门省心寄",
          svgName: "fe_daomen_nomal",
          link: "frontAirCheck"
        },
        {
          title: "上门取件",
          svgName: "fe_qujian_nomal",
          link: "PickupBespoke?isDefAddress=1"
        },
        {
          title: "进口服务",
          svgName: "jinkoufuwu",
          link: "importService/list"
        },
      ],
      // 物流工具
      logisticsToolsListone: [
        {
          title: "快递轨迹",
          imgUrl: '../../../../../../static/img/logisticsTools/icon／百运工具／快递轨迹@2x.png',
          link: "Special/query-page/index.htm"
        },
        {
          title: "小包轨迹",
          imgUrl: '../../../../../../static/img/logisticsTools/icon／百运工具／小包轨迹@2x.png',
          link: "Special/query-page/index.htm?queryType=1"
        },
        {
          title: "偏远地址",
          imgUrl: '../../../../../../static/img/logisticsTools/icon／百运工具／偏远地址@2x.png',
          link: "bywiki/remoteArea"
        },
        {
          title: "机场三字码",
          imgUrl: '../../../../../../static/img/logisticsTools/icon／百运工具／机场三字码@2x.png',
          link: "bywiki/airportCode"
        },
        {
          title: "送货地址",
          imgUrl: '../../../../../../static/img/logisticsTools/icon／百运工具／送货地址@2x.png',
          link: "bywiki/deliveryArea"
        },
        {
          title: "积载因素",
          imgUrl: '../../../../../../static/img/logisticsTools/icon／百运工具／积载因素@2x.png',
          link: "bywiki/stowFactor"
        },

      ],
      logisticsToolsListTwo: [
        {
          title: "集装箱参数",
          imgUrl: '../../../../../../static/img/logisticsTools/icon／百运工具／集装箱@2x.png',
          link: "bywiki/contaParameters"
        },
        {
          title: "报关代码",
          imgUrl: '../../../../../../static/img/logisticsTools/icon／百运工具／报关代码@2x.png',
          link: "bywiki/reportCode"
        },
        {
          title: "船公司",
          imgUrl: '../../../../../../static/img/logisticsTools/icon／百运工具／船公司@2x.png',
          link: "bywiki/shipCompany"
        },
        {
          title: "申报要素",
          imgUrl: '../../../../../../static/img/logisticsTools/icon／百运工具／申报要素@2x.png',
          link: "bywiki/declareElements"
        },
        {
          title: "海关编码",
          imgUrl: '../../../../../../static/img/logisticsTools/icon／百运工具／海关编码@2x.png',
          link: "bywiki/customsCode"
        },
        {
          title: "计费重计算器",
          imgUrl: '../../../../../../static/img/logisticsTools/icon／百运工具／计费重@2x.png',
          link: "bywiki/heavyCharge"
        },
      ],
      logisticsToolsListTwoOne: [
        {
          title: "汇率换算器",
          imgUrl: '../../../../../../static/img/logisticsTools/icon／百运工具／汇率换算@2x.png',
          link: "bywiki/exchangeRate"
        },
        {
          title: "快递燃油费率",
          imgUrl: require('../../../../../../static/img/logisticsTools/icon／百运工具／快递燃油费率.png'),
          // imgUrl: require('../../../static/newStatic/img/logisticsTool/headerMenu/icon_wlgj_hlhs@2x.png'),
          link: "bywiki/expressFuelRate"
        },
      ],
      // logisticsToolsListone: [
      //   {
      //     title: "计费重计算器",
      //     // imgUrl: require('../../../static/img/logisticsTools/icon／百运工具／计费重@2x.png'),
      //     imgUrl: require('../../../../../../static/newStatic/img/logisticsTool/headerMenu/icon_wlgj_jfz@2x.png'),
      //     link: "bywiki/heavyCharge"
      //   },
      //   {
      //     title: "快递轨迹",
      //     // imgUrl: require('../../../static/img/logisticsTools/icon／百运工具／快递轨迹@2x.png'),
      //     imgUrl: require('../../../../../../static/newStatic/img/logisticsTool/headerMenu/icon_wlgj_kdgj@2x.png'),
      //     link: "Special/query-page/index.htm"
      //   },
      //   {
      //     title: "小包轨迹",
      //     // imgUrl: require('../../../static/img/logisticsTools/icon／百运工具／快递轨迹@2x.png'),
      //     imgUrl: require('../../../../../../static/newStatic/img/logisticsTool/headerMenu/icon_wlgj_xbgj@2x.png'),
      //     link: "Special/query-page/index.htm?queryType=1"
      //   },
      //   {
      //     title: "偏远地址",
      //     // imgUrl: require('../../../static/img/logisticsTools/icon／百运工具／偏远地址@2x.png'),
      //     imgUrl: require('../../../../../../static/newStatic/img/logisticsTool/headerMenu/icon_wlgj_pydz@2x.png'),
      //     link: "bywiki/remoteArea"
      //   },
      //   {
      //     title: "机场三字码",
      //     // imgUrl: require('../../../static/img/logisticsTools/icon／百运工具／机场三字码@2x.png'),
      //     imgUrl: require('../../../../../../static/newStatic/img/logisticsTool/headerMenu/icon_wlgjx_szm@2x.png'),
      //     link: "bywiki/airportCode"
      //   },
      //   {
      //     title: "送货地址",
      //     // imgUrl: require('../../../static/img/logisticsTools/icon／百运工具／送货地址@2x.png'),
      //     imgUrl: require('../../../../../../static/newStatic/img/logisticsTool/headerMenu/icon_wlgj_shdz@2x.png'),
      //     link: "bywiki/deliveryArea"
      //   },


      // ],
      // logisticsToolsListTwo: [
      //    {
      //     title: "积载因素",
      //     // imgUrl: require('../../../static/img/logisticsTools/icon／百运工具／积载因素@2x.png'),
      //     imgUrl: require('../../../../../../static/newStatic/img/logisticsTool/headerMenu/icon_wlgj_jzys@2x.png'),
      //     link: "bywiki/stowFactor"
      //   },
      //   {
      //     title: "集装箱参数",
      //     // imgUrl: require('../../../static/img/logisticsTools/icon／百运工具／集装箱@2x.png'),
      //     imgUrl: require('../../../../../../static/newStatic/img/logisticsTool/headerMenu/icon_wlgj_jzx@2x.png'),
      //     link: "bywiki/contaParameters"
      //   },
      //   {
      //     title: "报关代码",
      //     // imgUrl: require('../../../static/img/logisticsTools/icon／百运工具／报关代码@2x.png'),
      //     imgUrl: require('../../../../../../static/newStatic/img/logisticsTool/headerMenu/icon_wlgj_bgdm@2x.png'),
      //     link: "bywiki/reportCode"
      //   },
      //   {
      //     title: "船公司",
      //     // imgUrl: require('../../../static/img/logisticsTools/icon／百运工具／船公司@2x.png'),
      //     imgUrl: require('../../../../../../static/newStatic/img/logisticsTool/headerMenu/icon_wlgj_cgs@2x.png'),
      //     link: "bywiki/shipCompany"
      //   },
      //   {
      //     title: "申报要素",
      //     // imgUrl: require('../../../static/img/logisticsTools/icon／百运工具／申报要素@2x.png'),
      //     imgUrl: require('../../../../../../static/newStatic/img/logisticsTool/headerMenu/icon_wlgj_sbys@2x.png'),
      //     link: "bywiki/declareElements"
      //   },
      //   {
      //     title: "海关编码",
      //     // imgUrl: require('../../../static/img/logisticsTools/icon／百运工具／海关编码@2x.png'),
      //     imgUrl: require('../../../../../../static/newStatic/img/logisticsTool/headerMenu/icon_wlgj_hgbm@2x.png'),
      //     link: "bywiki/customsCode"
      //   },

      // ],
      // logisticsToolsListTwoOne: [
      //   {
      //     title: "汇率换算器",
      //     imgUrl: require('../../../static/img/logisticsTools/icon／百运工具／汇率换算@2x.png'),
      //     // imgUrl: require('../../../../../../static/newStatic/img/logisticsTool/headerMenu/icon_wlgj_hlhs@2x.png'),
      //     link: "bywiki/exchangeRate"
      //   },
      // ],
      logisticsToolsListThree: [
        {
          title: "快递工具",
          svgName: '/tool_kuaidi_nomal',
          link: "Special/index.html?index=1"
        },
        {
          title: "空运工具",
          svgName: 'tool_kongyun_nomal',
          link: "Special/index.html?index=2"
        },
        {
          title: "FBA工具",
          svgName: 'tool_fba_nomal',
          link: "Special/index.html?index=3"
        },
        {
          title: "海运工具",
          svgName: 'tool_haiyun_nomal',
          link: "Special/index.html?index=4"
        },

      ],
      // 企业支持
      supportList: [
        {
          title: "运商通",
          imgUrl: require('../../../../../../static/newStatic/img/topNav/yst.png'),
          text: '跨境物流智能服务管家',
          link: "ystIndex"
        },
        {
          title: "开放平台",
          imgUrl: require('../../../../../../static/newStatic/img/topNav/open.png'),
          text: '百运接口一站式解决方案',
          link: "openPlatform"
        },
      ],
      // 关于我们
      aboutUsList: [
        {
          title: "关于百运",
          imgUrl: require('../../../../../../static/newStatic/img/topNav/about.png'),
          text: '科技承载物流',
          link: "aboutBy/aboutByCent"
        },
        {
          title: "招贤纳士",
          imgUrl: require('../../../../../../static/newStatic/img/topNav/careers.png'),
          text: '欢迎成为百运团队的一员',
          link: "aboutBy/joinUs"
        },
        {
          title: "联系我们",
          imgUrl: require('../../../../../../static/newStatic/img/topNav/contact.png'),
          text: '真诚邀请优质企业合作',
          link: "aboutBy/contact"
        },
      ],
      NewbieList: [],//帮助中心 UserGuide
      QuestionList: [],//帮助中心 CommonQuestion
      dropBg: false,//监听滚动条
      logisticToolMenu: [],//列表高亮显示 物流工具列表
      navListData: [],//列表数据
      CustomerName: "",//用户名称
      itemurl: '',//用户图片头像
      rightTopMessageShow: false,
      messageTotal: 0,
      show: false,
      svgUserInfo: 'geren_nomal',
      svgAdvise: 'fanjkui_nomal',
      svgLoginOut: 'tuichu-moren',
      svgMessage: 'xiaoxi_nomal',
      shouyeShow: false,//是否显示首页tip
      wuliuShow: false,//是否显示物流工具悬浮框
      knowShow: false,//了解百运
      isSelect: null,//移入菜单控制箭头旋转
      isShowEmailDialog: false,//是否显示邮箱验绑弹框
      isShowMobileDialog: false,//是否显示手机号验绑弹框
      isAuthentication: true, // 用户认证状态
      isBothBiddingError: false,//用户是否手机邮箱验绑都异常
      mobilePhone: "",//异常手机号
      email: "",//异常邮箱
    };
  },
  computed: {
    styleObject() {
      return {
        "--font-color-hover": !this.dropBg ? this.colorFzHover : this.commColor.commFzHover,//鼠标滑动 字体颜色
        // "--font-color-login": this.colorFzLogin,//登录字体颜色
      }
    },
  },
  created() {
    //高亮显示
    this.getLogisticToolMenu();
    // nav列表数据
    this.navListData = this.navListDataProps
    console.log("==== this.navListData", this.navListData);
    // this.initToken()
  },
  async mounted() {
    // bus.$on('loginSuccess', this.initToken)
    // this.initToken();
    let loginInfos = JSON.parse(sessionStorage.getItem("loginMessage"));
    this.loginInfos = loginInfos;
    console.log('this.loginInfos', loginInfos);
    if (loginInfos) {
      //获取客户验绑状态
      // 1 手机验绑异常 2 邮箱验绑异常 3 都异常
      let CustomAthensBind = loginInfos.CustomAthensBind
      this.mobilePhone = loginInfos.MobilePhone
      this.email = loginInfos.Mail
      console.log("CustomAthensBind", CustomAthensBind);
      if (CustomAthensBind == 1) {
        this.isShowMobileDialog = true
      } else if (CustomAthensBind == 2) {
        this.isShowEmailDialog = true
      } else if (CustomAthensBind == 3) {
        this.isShowMobileDialog = true
        this.isBothBiddingError = true
      }
      this.CustomerName = loginInfos.CustomerName;
      // 用户认证状态
      this.isAuthentication = loginInfos.IsAuthenticated == 2 ? true : false;
      //如果是子账号登录，则显示主账号的信息 RootCustomerInfo
      if (loginInfos.RootCustomerInfo) {
        this.itemurl = loginInfos.RootCustomerInfo.UserHeadImg;
      } else {
        this.itemurl = loginInfos.UserHeadImg;
      }
    } else {
      this.initToken()
    }
    console.log("loginInfos", loginInfos);

    // 年度问卷状态
    let isFalse = await this.getQuestionnaireState();
    this.isQuestion = !isFalse;
    let isFive = await this.GetQuestionaireShow();
    this.isFive = isFive;

    window.addEventListener("scroll", () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop >= this.navHeight.substring(0, this.navHeight.length - 2)) {
        this.dropBg = true;
      } else {
        this.dropBg = false;
      }
    });

  },
  watch: {},
  watchQuery: true,
  methods: {
    // 判断是否填写过年度调查问卷
    async getQuestionnaireState() {
      let that = this;
      return new Promise(async (resolve, reject) => {
        // let isLogin = getCookie("JWT-TOKEN");
        let isLogin = getCookie("JWT-TOKEN"); // 若存在用户ID则表示登录了
        if (!isLogin) {
          // 未登录不需要判断是否填写过此问卷
          // that.submitStatus = 0;
          return resolve(false);
        }

        // const customerId = getCookie('customerID') ? Number(getCookie('customerID')) : null;
        const customerId = getCookie('customerID') || 0;
        const visitId = 0; // 回访记录ID
        let questionnaireCode = this.isNewYear ? 'by20221227' : 'yx20240517'//'aa20131206'//'BY20230612';
        // 请求接口获取问卷状态
        const url =
          that.$api04 +
          "Basics/api/Questionnaire/GetQuestionnaireState?QuestionnaireCode=" +
          questionnaireCode +
          "&CustomerId=" +
          customerId +
          "&VisitId=" +
          visitId;

        const res = await post(url);
        if (res.IsOK) {
          // that.submitStatus = res.Results ? 2 : 0;
          return resolve(res.Results);
        }
      });
    },
    // 调查问卷回调事件
    async handlerQuestionnaireDialog(val) {
      // 判断是否填写过此调查问卷
      if (val) {
        let isFalse = await this.getQuestionnaireState();
        if (isFalse) {
          this.$message({
            type: "warning",
            message: '您已答卷，感谢反馈！',
          });
          this.questionnaireDialogValue = false;
        } else {
          this.questionnaireDialogValue = val;
        }
      } else {
        this.questionnaireDialogValue = val;
      }

    },
    //判断下单5个国际单客户
    async GetQuestionaireShow() {
      let that = this;
      return new Promise(async (resolve, reject) => {
        let isLogin = getCookie("JWT-TOKEN"); // 若存在用户ID则表示登录了
        if (!isLogin) {
          return resolve(false);
        }
        const customerId = getCookie("customerID") || 0;
        // 请求接口获取问卷状态
        let url = that.$api04 + "Basics/api/Questionnaire/GetQuestionaireShow?customerId=" + customerId;
        const res = await fetch(url);
        if (res.IsOK) {
          return resolve(res.Results);
        }
      });

    },
    goBaiyun() {
      // window.location.href = this.$nuxtPage
      // window.location.href = this.$nuxtPage
      this.browserHref(this.$nuxtPage, 1);
    },
    toMyBaiYun(url) {
      // window.location.href = url;
      this.browserHref("/" + url, 1);
    },

    // 跳转查价页面/物流工具页面
    goCheck(code, type) {
      // let openw = window.open()
      //window.location.href = this.$nuxtPage + code
      // let openw = window.open()

      let href = '/';
      if (type == 0) {
        // openw.location.href = this.$nuxtPage + "Special/index.html?index=" + code
        href = this.$nuxtPage + "Special/index.html?index=" + code
      } else {
        // openw.location.href = this.$nuxtPage + code
        href = this.$nuxtPage + code
      }

      this.browserHref(href, 2);

    },


    // 移入li框
    navOver(val) {
      this.navTopAtv = true
      if (val == 0) {
        this.shouyeShow = true
      }
      if (val == 3) {
        this.wuliuShow = true
      }
      if (val == 6) {
        this.knowShow = true
      }
      this.isSelect = val
    },
    navOut(val) {
      this.navTopAtv = false
      if (val == 0) {
        this.shouyeShow = false
      }
      if (val == 3) {
        this.wuliuShow = false
      }
      if (val == 6) {
        this.knowShow = false
      }
      this.isSelect = null
    },
    //控制首页的悬浮窗显示隐藏
    closeshouyeTip() {
      this.shouyeShow = false
    },
    showshouyeTip() {
      this.shouyeShow = true
    },
    //控制了解百运的悬浮窗显示隐藏
    closeKnowTip() {
      this.dropBg = false
      this.knowShow = false
    },
    showKnowTip() {
      this.dropBg = true
      this.knowShow = true
    },
    //控制物流工具的悬浮窗显示隐藏
    closewuliuTip() {
      this.wuliuShow = false
    },
    showwuliuTip() {
      this.wuliuShow = true
    },
    //搜索订单号、参考号、提单号
    submitSearch(val) {
      if (val) {
        let that = this;
        let ordKeyWord = val.trim(); //去首尾空格
        let url = this.$api04 + "Air/api/Statistics/QuerySearchOrder";
        let param = {
          Keyword: ordKeyWord,
        };
        post(url, param).then((res) => {
          if (res.IsOK) {
            let ordList = res.Results[0];
            that.goDetail(ordList.WaybillType, ordList.WaybillNO);
          } else {
            that.$message({
              showClose: true,
              message: '没有查询到该订单',
              type: 'error'
            });
          }
        });
      }
    },
    //搜索订单结果  跳转对应详情页
    goDetail(type, ord) {
      // 订单类型:1快递 ，2 小包 (没有了)，3 空运，4海运整柜，5海运散货,20 FBA头程
      // var newWindow = window.open();
      let href = '/';
      if (type == 1) {
        // newWindow.location.href = this.$apiAir + "exp/expDetails?ord=" + ord;
        href = this.$apiAir + "exp/expDetails?ord=" + ord;
      }
      if (type == 3) {
        // newWindow.location.href = this.$apiAir + "air/airDetails?ord=" + ord;
        href = this.$apiAir + "air/airDetails?ord=" + ord;
      }
      if (type == 20) {
        // newWindow.location.href =
        //   this.$apiAir + "fba/order/detail?orderNo=" + ord;

        href =
          this.$apiAir + "fba/order/detail?orderNo=" + ord;
      }
      if (type == 4) {
        // newWindow.location.href =
        href =
          this.$apiAll +
          "CustomerCenter/Order/SeaFull/Details.aspx?WaybillNO=" +
          ord;
      }
      if (type == 5) {
        // newWindow.location.href =
        href =
          this.$apiAll +
          "CustomerCenter/Order/SeaBulk/Details.aspx?WaybillNO=" +
          ord;
      }

      this.browserHref(href, 2);
    },
    // 子列表跳转链接
    hrefMenu(index, titleItem, navItem) {
      // let query = {
      //   index: index,
      // }
      // this.$router.push({
      //   path: titleItem.urlSubHref,
      //   query: navItem.titleId == 3 ? query : '',
      // });
      // let openW = window.open()
      let href = '/';
      if (navItem.titleId == 3) {
        // window.location.href = this.$nuxtPage + titleItem.urlSubHref + "?index=" + index;
        href = this.$nuxtPage + titleItem.urlSubHref + "?index=" + index;
      } else {
        // window.location.href = this.$nuxtPage + titleItem.urlSubHref;
        href = this.$nuxtPage + titleItem.urlSubHref;
      }

      this.browserHref(href, 1);

    },
    async getLogisticToolMenu() {
      // // 获取所有的物流工具列表数据
      const url = this.$api04 + "Basics/api/LogisticsTool/GetLogisticsToolColumnList";
      // let params = getCookie("JWT-TOKEN")
      //   ? { customerID: getCookie("customerID") || 0 }
      //   : {};
      let params = {}
      const list = await post(url, params);
      if (list.IsOK && list.Results) {
        const data = list.Results;
        data.forEach((item) => {
          this.logisticToolMenu.push({
            title: item.ColumnName,
            logo: this.$nuxtPage + item.Logo,
            urlSubHref: 'Special/index.html'
          });
        });

        // 后期改动封装成为单个组件
        this.navListData.forEach((subItem) => {
          if (subItem.titleId == 3) {
            subItem.moreSubData = this.logisticToolMenu
          }
        })
      }
    },
    //地址栏高亮显示
    isHig() {
      let navActiv = 7
      return navActiv
    },
    CustomerInfo() {
      this.api.url =
        // this.$api02 + "/api/EbayCustomer/CustomerInfo/GetCustomerInfoByToken";
        this.$api04 + "Basics/api/CustomerInfo/GetCustomerInfoByToken";
      this.api.param = {};
      return new Promise((resolve, reject) => {
        post(this.api.url, this.api.param).then((response) => {
          resolve(response);
        });
      });
    },
    async initToken() {
      let res = await this.CustomerInfo();
      this.CustomerName = res.Results.CustomerName;
      this.isAuthentication = res.Results.IsAuthenticated == 2 ? true : false;
      //如果是子账号登录，则显示主账号的信息 RootCustomerInfo
      if (res.Results.RootCustomerInfo) {
        this.itemurl = res.Results.RootCustomerInfo.UserHeadImg;
      } else {
        this.itemurl = res.Results.UserHeadImg;
      }
      this.loginInfos = res.Results
      //用户信息对象
      sessionStorage.setItem("loginMessage", JSON.stringify(res.Results));
      sessionStorage.setItem("SalesInfos", JSON.stringify(res.Results));

    },
    // initToken() {
    //   this.api.url = this.$api02 + "/api/CustomerInfo/GetCustomerInfoByToken";
    //   this.api.param = {};
    //   post(this.api.url, this.api.param).then((res) => {

    //     if (res.Results) {
    //       this.CustomerName = res.Results.CustomerName;
    //       //如果是子账号登录，则显示主账号的信息 RootCustomerInfo
    //       if (res.Results.RootCustomerInfo) {
    //         this.itemurl = res.Results.RootCustomerInfo.UserHeadImg;
    //       } else {
    //         this.itemurl = res.Results.UserHeadImg;
    //       }
    //       bus.$emit("SalesInfos", res.Results)
    //       //用户信息对象
    //       sessionStorage.setItem("UserInfos", JSON.stringify(res.Results));
    //     }
    //   })
    // },
    delToken() {
      delCookie("CustomerName")
      delCookie("UserSex")
      delCookie("UserFrom");
      delCookie("JWT-TOKEN");
      delCookie("customerID");
      delCookie("CustomerOwnerType");
      delCookie("CustomerInfo");
      sessionStorage.removeItem("SalesInfos");
      sessionStorage.removeItem("loginMessage");
      if (sessionStorage.getItem('SalesInfos') && ![null, 'null', undefined, 'undefined'].includes(sessionStorage.getItem('SalesInfos'))) {
        sessionStorage.removeItem("SalesInfos");
      }
      if (sessionStorage.getItem('SalesInfos') && ![null, 'null', undefined, 'undefined'].includes(sessionStorage.getItem('SalesInfos'))) {
        sessionStorage.removeItem("loginMessage");
      }

    },
  },
  beforeDestroy() {
    // 实例销毁之前对点击事件进行解绑
    window.removeEventListener("scroll", () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > this.navHeight.substring(0, this.navHeight.length - 2)) {
        this.dropBg = true;
      } else {
        this.dropBg = false;
      }
    });
  },
};
</script>
<style lang="scss" scoped="scoped">
.headportrait {
  justify-content: flex-end;
  // width: 128px;
  .w_ellipsis {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 64px;
    line-height: 64px;
  }
}
.new-tab {
  display: inline-block;
  width: 30px;
  height: 14px;
  background: url("../../../../../../static/newStatic/img/label_overall_new.png");
  background-size: 100% 100%;
  position: absolute;
  top: 12px;
  left: 46px;
}
.my-baiYun {
  position: relative;

  .my-baiYun-icon {
    cursor: default;
    position: absolute;
    left: 70px;
    top: -2px;
  }
}
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.bottom_line_rel {
  position: relative;
  &:hover {
    font-weight: 500;
    transition: all 0.5s;
    .aCol {
      font-weight: normal;
    }
  }
}
.aHov:hover {
  .aCol {
    font-weight: bold;
  }
}
.active .title-item {
  color: var(--font-color-hover);
  font-weight: 500;
  transition: all 0.5s;
  line-height: 24px;
}
.title-item {
  height: 64px;
  display: inline-block;
}
.bq-img {
  display: inline;
  margin-top: -7px;
  position: absolute;
  top: 12px;
  right: -4px;
}

.bottom_line_nav {
  width: 100%;
  height: 2px;
  background: var(--font-color-hover);
  position: absolute;
  bottom: 0;
  border-radius: 1px;
  transition: all 0.5s;
}

.login-btn {
  border-radius: 20px;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  &:hover {
    color: var(--font-color-hover);
    transition: all 0.5s;
  }
}

// 登录 | 注册
.line-cut {
  width: 1px;
  height: 18px;
  margin: 0 24px;
}
// 头像
.info_login {
  width: 32px;
  height: 32px;
  border: 1px solid #e0e0e0;
  border-radius: 50px;
  overflow: hidden;
  margin-right: 8px;
  box-sizing: border-box;
}
.info_name_title {
  color: #333333;
  font-size: 14px;
  width: max-content;
  cursor: pointer;
  &:hover {
    color: #0046b9;
    font-weight: 550;
  }
}

.topNav {
  color: #fff;
  width: inherit;
  min-width: fit-content;
  max-width: initial;
  top: 0px;
  z-index: 1000;
  //width: 100%;
  min-width: 1440px;
  transition: 0.5s;
  a {
    color: inherit;
  }
}
//全新升级图片
.flex_center2 {
  .sj_img {
    position: absolute;
    top: 7px;
    left: 30px;
  }
}

.navContent {
  //width: 1200px;
  // height: 70px;
  //margin: auto;
  display: flex;
  justify-content: space-between;
  .flex_center2 {
    display: flex;
  }
  ul {
    width: 711px;
  }
}
.navContent .navLeft {
  color: #fff;
  font-size: 16px;
  //display: inline-flex;
  align-items: center;
  .icon-width {
    width: 104px;
    height: 34px;
    background-size: 100% 100%;
    margin: 0 48px;
    cursor: pointer;
  }
}
.navContent .navLeft ul li {
  // margin-right: 32px;
  margin-right: 24px;
  display: inline-block;
  cursor: pointer;
}

.navContent .navLeft ul li a.active {
  border-bottom: 1px solid #0046b9;
  color: var(--font-color-hover);
  padding-bottom: 10px;
}

.navContent .navLeft ul li.lineGary {
  color: #bababa;
  margin: 0 0px !important;
}

.titleActive:hover {
  color: var(--font-color-hover);
  margin-top: 0px;
}

// 鼠标移动
.navContent ul .titleActive a:hover {
  color: var(--font-color-hover);
}

.tishi {
  position: relative;
}
.tishi img {
  vertical-align: middle;
  cursor: pointer;
}
.tishi:hover div {
  display: block;
}

.isSelect0 {
  width: 16px;
  height: 16px;
  background: url("../../../../../../static/img/左侧导航／浅色／未选中／下拉蓝@2x.png");
  background-size: 100% 100%;
  transform: rotate(180deg);
  transition: all 0.2s;
}
.unSelect0 {
  width: 16px;
  height: 16px;
  background: url("../../../../../../static/img/左侧导航／浅色／未选中／下拉黑@2x.png");
  background-size: 100% 100%;
  transition: all 0.2s;
  transform: rotate(0);
}
.isSelect1 {
  width: 16px;
  height: 16px;
  background: url("../../../../../../static/img/左侧导航／浅色／未选中／下拉蓝@2x.png");
  background-size: 100% 100%;
  // position: relative;
  // bottom: 5px;
  transform: rotate(180deg);
  transition: all 0.2s;
}
.unSelect1 {
  width: 16px;
  height: 16px;
  background: url("../../../../../../static/img/左侧导航／浅色／未选中／下拉黑@2x.png");
  background-size: 100% 100%;
  transition: all 0.2s;
  transform: rotate(0);
}
.isSelect2 {
  width: 16px;
  height: 16px;
  background: url("../../../../../../static/img/左侧导航／浅色／未选中／下拉蓝@2x.png");
  background-size: 100% 100%;
  // position: relative;
  // bottom: 5px;
  transform: rotate(180deg);
  transition: all 0.2s;
}
.unSelect2 {
  width: 16px;
  height: 16px;
  background: url("../../../../../../static/img/左侧导航／浅色／未选中／下拉黑@2x.png");
  background-size: 100% 100%;
  transition: all 0.2s;
  transform: rotate(0);
}

.isSelect3 {
  width: 16px;
  height: 16px;
  background: url("../../../../../../static/img/左侧导航／浅色／未选中／下拉蓝@2x.png");
  background-size: 100% 100%;
  // position: relative;
  // bottom: 5px;
  transform: rotate(180deg);
  transition: all 0.2s;
}
.unSelect3 {
  width: 16px;
  height: 16px;
  background: url("../../../../../../static/img/左侧导航／浅色／未选中／下拉黑@2x.png");
  background-size: 100% 100%;
  transition: all 0.2s;
  transform: rotate(0);
}
.isSelect4 {
  width: 16px;
  height: 16px;
  background: url("../../../../../../static/img/左侧导航／浅色／未选中／下拉蓝@2x.png");
  background-size: 100% 100%;
  // position: relative;
  // bottom: 5px;
  transform: rotate(180deg);
  transition: all 0.2s;
}
.unSelect4 {
  width: 16px;
  height: 16px;
  background: url("../../../../../../static/img/左侧导航／浅色／未选中／下拉黑@2x.png");
  background-size: 100% 100%;
  transition: all 0.2s;
  transform: rotate(0);
}

.isSelect5 {
  width: 16px;
  height: 16px;
  background: url("../../../../../../static/img/左侧导航／浅色／未选中／下拉蓝@2x.png");
  background-size: 100% 100%;
  // position: relative;
  // bottom: 5px;
  transform: rotate(180deg);
  transition: all 0.2s;
}
.unSelect5 {
  width: 16px;
  height: 16px;
  background: url("../../../../../../static/img/左侧导航／浅色／未选中／下拉黑@2x.png");
  background-size: 100% 100%;
  transition: all 0.2s;
  transform: rotate(0);
}
// .tishi:hover .jiantou_select {
//   transform: rotate(90deg);
//   // -ms-transform: rotate(180deg); /* IE 9 */
//   // -moz-transform: rotate(180deg); /* Firefox */
//   // -webkit-transform: rotate(180deg); /* Safari å’Œ Chrome */
//   // -o-transform: rotate(180deg); /* Opera */
//   transition: all 0.2s;
//   background: url("../../../../../../static/img/高亮@1x.png");
// }
// .tishi:hover .jiantou_unselect {
//   transform: rotate(0);
//   // -ms-transform: rotate(180deg); /* IE 9 */
//   // -moz-transform: rotate(180deg); /* Firefox */
//   // -webkit-transform: rotate(180deg); /* Safari å’Œ Chrome */
//   // -o-transform: rotate(180deg); /* Opera */
//   transition: all 0.2s;
//   background: url("../../../../../../static/img/默认@1x.png");
// }
.topTipBox {
  display: none; //当鼠标移出不显示
  position: absolute;
  left: -8px;
  top: 62px;
  z-index: 999;
  border-radius: 4px;
}
.first_ul {
  margin-left: 24px;
}
.navBoxSub-shadow {
  // margin: 8px 0 0 0;//不显示间距
  // box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  // border-radius: 4px;
  box-shadow: 0px 4px 4px -3px rgba(0, 0, 0, 0.08),
    0px 8px 8px 1px rgba(0, 0, 0, 0.04), 0px 4px 16px 2px rgba(0, 0, 0, 0.04);
  margin-top: 2px;
}
.navBoxSub {
  padding: 8px;
  background: #fff;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #333333;
  border-radius: 8px;
  border-top: solid 1px rgba(221, 221, 221, 0.56);
}
.navBoxSub_title {
  text-align: center;
  width: 72px;
  height: 32px;
  border-radius: 4px;
  line-height: 32px;
  &:hover {
    background: rgba(0, 70, 185, 0.1); //#f7f8fa;
    color: #0046b9;
    font-weight: 600;
  }
}

.nab_triangle {
  background: url("../../../../../../static/img/arrow-icon-s.png") no-repeat;
  width: 18px;
  height: 8px;
  display: block;
  position: absolute;
  top: 1px;
  left: 36%;
  z-index: 9999;
}
.topTipBox h3 {
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: #333333;
  line-height: 36px;
}

.logo-title {
  width: 128px;

  &:hover {
    .topTipBox-login {
      display: block;
    }
  }
}
.topTipBox-login {
  display: none; //当鼠标移出不显示
  position: absolute;
  z-index: 999;
  width: 140px;
  height: 90px;

  .navBoxSub-login {
    position: relative;
    left: 34px;
    // left: 10px;
    //top: 48px;
    //margin: 8px 0 0 0;//不显示间距
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    color: #333;
    font-size: 13px;
    width: 96px;
    // width: 104px;
    box-sizing: border-box;
  }
  .login-sub-title {
    width: 80px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    cursor: pointer;
    color: #333 !important;
    border-radius: 4px;

    // a {
    //   &:hover {
    //     color: #0046b9 !important;
    //   }
    // }
    &:hover {
      background: rgba(0, 70, 185, 0.1); //#f7f8fa;
      font-weight: 550;
      color: #0046b9 !important;
    }
  }
  .line_br {
    // margin: 8px 0;
    // width: 64px;
    // height: 1px;
    // background: #e0e0e0;
  }
}

.topTipBox p:hover {
  -webkit-transition: background-color 0.8s;
  -moz-transition: background-color 0.8s;
  -ms-transition: background-color 0.8s;
  -o-transition: background-color 0.8s;
  transition: background-color 0.8s;
}
.topTipBox h3 {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
}

.navRight {
  margin-right: 24px;
  .marg-l-r16 {
    margin: 0 16px;
    height: 20px;
    line-height: 20px;
  }
}
.right-btn-list {
  display: flex;
  flex-direction: row;
}
.login-btn {
  border-radius: 20px;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
}
// 注册
.registered_btn {
  width: 64px;
  height: 32px;
  border: 1px solid #ffffff;
  border-radius: 4px;
  line-height: 32px;
  text-align: center;
  box-sizing: border-box;
}
// 登录
.register_btn {
  color: #0046b9;
  width: 64px;
  height: 32px;
  background: #ffffff;
  border-radius: 4px;
  line-height: 32px;
  text-align: center;
}

.topNav-dropBg {
  transition: background 0.5s;
  background: #fff !important;
}
.noshow {
  width: 106px;
  position: absolute;
  right: 0px;
  z-index: 999;
  background: #fff;
  // box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  // border-color: #eaeaea;
  // border-radius: 4px;
  //border: 1px solid #ddd;
  margin-right: 24px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.1);
  border-radius: 0px 0px 8px 8px;
  border-top: solid 1px rgba(221, 221, 221, 0.56);
  ul {
    width: 106px;
  }
}

.noshow ul li {
  padding: 5px 0;
}
.noshow .quit {
  border-top: 1px solid #ddd;
}

.noshow li a {
  padding: 2px 8;
  line-height: 26px;
  color: #333333;
  font-size: 14px;
  //width: 106px;
  display: block;
  text-align: center;
  width: 90px;
  height: 32px;
  margin: 0 8px;
  line-height: 32px;
  &:hover {
    color: #0046b9;
    background: rgba(0, 70, 185, 0.1);
    border-radius: 3px;
    font-weight: 550;
  }
}
// .noshow li a:hover {
//   background: #eee;
// }
.noshow i {
  padding: 0 5px 0 15px;
}
.img--right-icon {
  display: inline-block;
  padding: 0px 10px 0 20px;
  position: relative;
  top: 2px;
}

.shouye_show {
  border-top: solid 1px rgba(221, 221, 221, 0.56);
  box-sizing: border-box;
  min-width: 792px;
  height: 240px;
  background: #ffffff;
  box-shadow: 0px 4px 4px -3px rgba(0, 0, 0, 0.08),
    0px 8px 8px 1px rgba(0, 0, 0, 0.04), 0px 4px 16px 2px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  position: absolute;
  top: 64px;
  padding: 0 16px;
  .show_title {
    height: 48px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #777777;
    line-height: 48px;
    border-bottom: solid 1px #ebebeb;
    box-sizing: border-box;
  }
  .list_1 {
    display: flex;
    height: 72px;
    align-items: center;
  }
}
.shouye_item {
  width: 120px;
  height: 40px;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  background: #ffffff;
  color: #333333;
  display: flex;
  align-items: center;
  margin-right: 8px;
  cursor: pointer;
  &:hover {
    background: rgba(231, 236, 248, 0.8);
    color: #0046b9;
  }
  .svgStyle {
    margin: 0 8px;
  }
}

.wuliu_show {
  width: 888px;

  z-index: 99999;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 4px 4px -3px rgba(0, 0, 0, 0.08),
    0px 8px 8px 1px rgba(0, 0, 0, 0.04), 0px 4px 16px 2px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  position: absolute;
  top: 64px;
  left: 498px;
  padding: 0 16px 16px;
  // border-top: solid 1px rgba(221, 221, 221, 0.56);
  .wuliu_title {
    height: 48px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #777777;
    line-height: 48px;
    border-bottom: solid 1px #ebebeb;
  }
  .logisticTool-title {
    margin-top: 16px;
  }
  .list_1 {
    display: flex;
    margin: 16px 0;
  }
  .list_2 {
    display: flex;
    margin-bottom: 16px;
  }
  .list_21 {
    display: flex;
    // margin-bottom: 16px;
  }
  .list_3 {
    display: flex;
    flex-wrap: wrap;
    margin-top: 16px;
  }
}
.wuliu_item {
  width: 136px;
  height: 40px;

  border-radius: 4px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  background: #ffffff;
  color: #333333;
  display: flex;
  align-items: center;
  margin-right: 8px;
  cursor: pointer;
  position: relative;
  &:hover {
    background: rgba(231, 236, 248, 0.8);
    color: #0046b9;
    .logistics_0 {
      background: url("../..//../../../../static/img/logisticsTools/icon／其他工具／快递工具-悬停@2x.png");
      background-size: 100% 100%;
    }
    .logistics_1 {
      background: url("../..//../../../../static/img/logisticsTools/icon／其他工具／空运工具-悬停@2x.png");
      background-size: 100% 100%;
    }
    .logistics_2 {
      background: url("../..//../../../../static/img/logisticsTools/icon／其他工具／FBA工具-悬停@2x.png");
      background-size: 100% 100%;
    }
    .logistics_3 {
      background: url("../..//../../../../static/img/logisticsTools/icon／其他工具／海运工具-悬停@2x.png");
      background-size: 100% 100%;
    }
    .logistics_4 {
      background: url("../..//../../../../static/img/logisticsTools/ic_gongju_hover.png");
      background-size: 100% 100%;
    }
  }
  .svgStyle {
    margin: 0 8px;
    width: 24px;
    height: 24px;
    background-size: 100% 100%;
  }
}
.new-logisticstool {
  display: inline-block;
  width: 30px;
  height: 14px;
  background: url("../../../../../../static/newStatic/img/label_overall_new.png");
  background-size: 100% 100%;
  position: absolute;
  right: 0;
  top: 0;
}
.knowBy_show {
  width: 448px;
  background: #ffffff;
  box-shadow: 0px 4px 4px -3px rgba(0, 0, 0, 0.08),
    0px 8px 8px 1px rgba(0, 0, 0, 0.04), 0px 4px 16px 2px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  box-sizing: border-box;
  padding: 0 16px 14px;
  position: absolute;
  top: 64px;
  z-index: 9999;
  left: 780px;
  display: flex;
  justify-content: space-between;
  .knowBy-show-content {
    width: 200px;
    .content-title {
      height: 46px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #777777;
      line-height: 46px;
      border-bottom: solid 1px #ebebeb;
      margin-bottom: 14px;
    }
    .item {
      width: 200px;
      height: 64px;
      border-radius: 8px;
      display: flex;
      transition: background 0.2s;
      background: #fff;
      margin-bottom: 5px;
      cursor: pointer;
      &:hover {
        background: #f7f8fa;
      }
      img {
        width: 24px;
        height: 24px;
        margin: 9px 8px 0 6px;
      }
      .item-title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 14px;
        color: #333333;
        line-height: 22px;
        margin: 10px 0 3px;
      }
      .item-text {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 13px;
        color: #777777;
        line-height: 20px;
      }
    }
  }
}
.logistics_0 {
  background: url("../..//../../../../static/img/logisticsTools/icon／其他工具／快递工具-默认@2x.png");
}
.logistics_1 {
  background: url("../..//../../../../static/img/logisticsTools/icon／其他工具／空运工具-默认@2x.png");
}
.logistics_2 {
  background: url("../..//../../../../static/img/logisticsTools/icon／其他工具／FBA工具-默认@2x.png");
}
.logistics_3 {
  background: url("../..//../../../../static/img/logisticsTools/icon／其他工具／海运工具-默认@2x.png");
}
.logistics_4 {
  background: url("../..//../../../../static/img/logisticsTools/ic_gongju_normal.png");
}
.xiala-enter,
.xiala-leave-to {
  opacity: 0;
}

.xiala-enter-to,
.xiala-leave {
  opacity: 1;
}
.xiala-enter-active,
.xiala-leave-active {
  transition: all 0.3s;
}
.wuliu_item:nth-of-type(6n) {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/backstageManagement/home/public/navTopHeader/index.vue